import Vue from 'vue'
import { abilitiesPlugin } from '@casl/vue'
import ability from './ability'
import * as utils from './utils'
Vue.use(abilitiesPlugin, ability)

export const useUtils = () => ({
    ...utils,
})

export const _ = null

